module.exports = __webpack_public_path__ + "static/dgsp-non-green-4fbe6aaaa5b91abdf81b2f9d556611b0.png";